import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";

const style = {
	position: "absolute" as "absolute",
	top: "50%",
	left: "50%",
	transform: "translate(-50%, -50%)",
	width: 420,
	bgcolor: "background.paper",
	boxShadow: 24,
	p: 4,
};

type ModalConfirmWithTextProps = {
	open: boolean;
	title?: string;
	description: string;
	confirmationValue: string;
	confirmLabel?: string;
	handleModalClose: () => void;
	handleConfirm: () => void;
	loading?: boolean;
};

export default function ModalConfirmWithText({
	open,
	title = "ATENÇÃO",
	description,
	confirmationValue,
	confirmLabel = "Confirmar",
	handleModalClose,
	handleConfirm,
	loading = false,
}: ModalConfirmWithTextProps) {
	const [typedValue, setTypedValue] = useState("");

	useEffect(() => {
		if (!open) setTypedValue("");
	}, [open]);

	const isConfirmDisabled = typedValue !== confirmationValue;

	return (
		<Modal
			open={open}
			aria-labelledby="modal-confirm-text-title"
			aria-describedby="modal-confirm-text-description"
		>
			<Box sx={style}>
				<Typography
					id="modal-confirm-text-title"
					variant="h5"
					component="h2"
					textAlign="center"
				>
					{loading ? "AGUARDE..." : title}
				</Typography>
				<Typography
					id="modal-confirm-text-description"
					sx={{ mt: 2 }}
					textAlign="center"
				>
					{loading ? <CircularProgress color="secondary" /> : description}
				</Typography>
				{loading ? (
					<></>
				) : (
					<>
						<Typography sx={{ mt: 3 }}>
							Digite <strong>"{confirmationValue}"</strong> para confirmar:
						</Typography>
						<TextField
							fullWidth
							sx={{ mt: 1 }}
							value={typedValue}
							placeholder={confirmationValue}
							onChange={(e) => setTypedValue(e.target.value)}
						/>
						<Grid
							container
							gap={3}
							marginTop={3}
							alignItems="center"
							justifyContent="center"
						>
							<Button
								variant="contained"
								size="large"
								sx={{ color: "white", backgroundColor: "red" }}
								onClick={handleModalClose}
							>
								Cancelar
							</Button>
							<Button
								variant="contained"
								size="large"
								color="success"
								disabled={isConfirmDisabled}
								onClick={handleConfirm}
							>
								{confirmLabel}
							</Button>
						</Grid>
					</>
				)}
			</Box>
		</Modal>
	);
}
